export default {
  validateEmail(emailAddress) {
    return /^[A-Z0-9’._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailAddress);
  },
  validateDate(date) {
    return /^(19[7-9]\d|20([0-4]\d|50))-[\d]{2}-[\d]{2}$/i.test(date);
  },
  validateNumber(number) {
    return /^[\d]+$/i.test(number);
  },
  validateCurrency(currency) {
    return /^(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{2})?$/i.test(currency);
  },
  validatePhone(phoneNumber) {
    return /^\d{3}-\d{3}-\d{4}(\sx[\d]+)?$/gi.test(phoneNumber);
  },
  validateRequired(requiredFields, values) {
    const errors = {};
    requiredFields.forEach((field) => {
      if (!values[field]) {
        errors[field] = 'Required';
      }
    });
    return errors;
  },
  validateVin(vin) {
    if (vin.length === 17 && vin.match(/[a-zA-Z]/) && vin.match(/[0-9]/) && !/[^a-zA-Z0-9]/.test(vin)) {
      return true;
    }
    return false;
  },
  validateLengthRange(field, start, end) {
    return (field.length === start || field.length === end);
  },
  validateLength(errors, fieldsDetails) {
    const lengthErrors = errors;
    fieldsDetails.forEach((fieldData) => {
      if (fieldData.value && !(fieldData.value.length >= fieldData.min && fieldData.value.length <= fieldData.max)) {
        if (fieldData.min === fieldData.max) {
          lengthErrors[fieldData.field] = `${fieldData.label} length should be ${fieldData.min}`;
        }
        else {
          lengthErrors[fieldData.field] = `${fieldData.label} Min ${fieldData.min} and Max  ${fieldData.max} characters required.`;
        }
      }
    });
    return lengthErrors;
  },
  validatePasswordSpecialRule(password) {
    return /[~`!#@$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(password) && /\d/.test(password);
  },
  validateAutotecID(autotecID) {
    return /^[A-Za-z]{4}[0-9]{4}$/i.test(autotecID);
  },
  validateDates(startDate, endDate) {
    return new Date(startDate) <= new Date(endDate);
  },
  checkValueExist(key, value, list) {
    let exist = false;
    if (Array.isArray(list))
      list.forEach((val) => {
        if (val[key] && value && val[key].toLowerCase() === value.toLowerCase()) {
          exist = true;
        }
      });
    return exist;
  },
  validateFileContent(fileContent) {
    return /[^ -~]+/g.test(fileContent);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/ValidationHelper.js